export const linkedInProfilesArticle = {
  title: 'LinkedIn Enhancer: Personal vs Business Profiles',
  slug: 'linkedin-profiles',
  content: `LinkedIn Enhancer: Personal vs Business Profiles

Switch between the two profile views using the tabs.

1) Personal Profile
- Optimize the founder or individual profile content.

2) Business Profile
- Manage the company LinkedIn profile details.

3) Navigate with hashes
- Use #personal or #business in the URL to open the tab directly.
`,
};
